import React from "react";

export default function Web_CSS() {
  return (
    <div>
      <h1>What is CSS</h1>
      <p>
        Route: <code>/web/css</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
